import { IonPage } from "@ionic/react";
import { type ReactElement } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { useDefaultAuthScreen } from "./hooks/useDefaultAuthScreen";
import { LoginSignUpPage } from "./Page";

export function IonLoginSignUpRoutes(): ReactElement {
  const match = useRouteMatch();
  const { defaultAuthMode } = useDefaultAuthScreen();

  return (
    <Switch>
      <Route exact path={`${match.url}/:authMode`}>
        <IonPage>
          <LoginSignUpPage />
        </IonPage>
      </Route>
      <Route exact path={match.url}>
        <Redirect to={`${match.url}/${defaultAuthMode}`} />
      </Route>
    </Switch>
  );
}
